module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['mint-steps', 'mt-bg-white', ("mint-steps--" + _vm.direction)]
  }, [(_vm.title || _vm.description) ? _c('div', {
    staticClass: "mint-steps__status mt-bColor-grey-lv5"
  }, [(_vm.iconClass || _vm.$slots.icon) ? _c('div', {
    staticClass: "mint-steps__icon"
  }, [_vm._t("icon", [_c('mt-icon', {
    class: _vm.iconClass
  })])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mint-steps__message"
  }, [_c('div', {
    staticClass: "mint-steps__message-wrapper"
  }, [_c('div', {
    staticClass: "mint-steps__title mt-color-grey",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-steps__desc mt-color-grey-lv3",
    domProps: {
      "textContent": _vm._s(_vm.description)
    }
  })])]), _vm._v(" "), _vm._t("message-extra")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mint-steps__items",
    class: [{
      'mint-steps__items--alone': !_vm.title && !_vm.description
    }],
    style: ({
      'padding-left': _vm.direction === 'vertical' ? (_vm.paddingLeft + 'px') : '0'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df924d5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/steps/src/steps.vue
// module id = 181
// module chunks = 0